<template>
	<div>
		<vxe-modal v-model="exportNoticeShow" show-footer @show="onExportNoticeShow"
			:before-hide-method="beforeExportNoticeClose" height="600" width="500">
			<template #title>
				<span>导出面板</span>
			</template>
			<template #default>
				<el-divider content-position="left">表单</el-divider>
				<vxe-checkbox-group class="group" v-model="exportForms" size="mini">
					<vxe-checkbox v-for="(item,index) in forms" :key="index" :label="item.label" :content="item.title"
						:disabled="item.type=='main'"></vxe-checkbox>
				</vxe-checkbox-group>
				<template
					v-if="list.toolbarButtonConfig.includes('exportcurrent') ||list.toolbarButtonConfig.includes('exportall')">
					<el-divider content-position="left">数据</el-divider>
					<el-radio-group class="group" v-model="exportType" size="mini">
						<el-radio-button label="current" border
							v-if="list.toolbarButtonConfig.includes('exportcurrent')">当前数据</el-radio-button>
						<el-radio-button label="total" border v-if="list.toolbarButtonConfig.includes('exportall')">所有数据
						</el-radio-button>
					</el-radio-group>
				</template>

				<template v-for="(item,index) in exportConfig">
					<div :key="index">
						<el-divider content-position="left">{{item.title}}</el-divider>
						<el-radio-group v-model="exportFieldType" size="mini" class="group"
							@change="exportFieldTypeChange" v-if="item.type=='column'">
							<el-radio-button v-for="(item) in exportConbineColumn" :key="item.label" :label="item.label"
								border>{{item.title}}</el-radio-button>
						</el-radio-group>
						<vxe-checkbox-group style="width: 100%;" v-model="item.select" size="mini"
							@change="exportColumnChange">
							<vxe-checkbox style="width: 25%;margin-left: 10px;margin-bottom: 4px;"
								v-for="(_item,_index) in item.data" :label="_item.id" :content="_item.label"
								:key="_index">
							</vxe-checkbox>
						</vxe-checkbox-group>
					</div>
				</template>
			</template>
		</vxe-modal>

		<div style="display: none;">
			<vxe-grid v-bind="gridOptions" :ref="tableRef"></vxe-grid>
		</div>
	</div>
</template>
<style>

</style>
<style scoped>
	.group {
		margin: 10px 0px;
		width: 100%;
		margin-left: 10px;
	}
</style>
<script>
	export default {
		name: 'export',
		props: {

			forms: {
				type: Array,
				default: () => {
					return null
				}
			},
			tableColumn: {
				type: Array,
				default: () => {
					return null
				}
			},
			moduleName: {
				type: String,
				default: () => {
					return ''
				}
			},
			windowName: {
				type: String,
				default: () => {
					return 'export'
				}
			},
			reportName: {
				type: String,
				default: () => {
					return ''
				}
			},
			listType: {
				type: String,
				default: () => {
					return 'list'
				}
			},
			beforeexport: {
				type: Function,
				default: () => {
					return new Promise((reslove)=>{
						reslove()
					})
				}
			},
			afterexport: {
				type: Function,
				default: () => {
					return () => {}
				}
			}
		},
		data() {
			return {
				list: null,
				gridOptions: null,
				tableRef: Math.random(),
				exportConfig: [],
				exportRef: Math.random(),
				exportinit: false,
				exportSystemColumn: [{
					title: '全部',
					label: 'total',
					field: []
				}, {
					title: '自定义',
					label: 'customer',
					field: []
				}],
				exportCustomColumn: [],
				exportConbineColumn: [],
				exportForms: [],
				exportFieldType: 'total',
				exportNoticeShow: false,
				exportParam: [],
				exportType: 'current',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			this.list = this.$parent
		},
		computed: {

		},

		methods: {
			onExportNoticeShow() {
				if (!this.exportinit) {
					this.createExportForm()
					this.createExportColumn()
					this.createExportAttr()
					this.exportinit = true
				}
				this.exportFieldTypeChange()
			},
			beforeExportNoticeClose(e) {

				if (e.type == 'confirm') {
					this.exportConfig.forEach((item) => {
						if (item.field == 'column') {
							this.exportParam[item.field] = item.select
						} else {
							if (!this.exportParam.searchkey) {
								this.exportParam.searchkey = {}
							}
							this.exportParam.searchkey[item.field] = item.select
						}

					})
					this.exportParam.forms = this.exportForms
					if (this.exportParam.column.length == 0) {
						this.$message.error('导出字段不能为空')
						return new Error()
					} else {
						//console.log(this)
						this.exportApi()
					}
				}
			},

			createExportForm() {
				if (this.forms) {
					this.forms.forEach((item) => {
						if (item.type == 'main') {
							this.exportForms.push(item.label)
						}
					})
				}

			},
			createExportColumn() {
				let column = []

				this.tableColumn.forEach((item) => {
					this.exportSystemColumn[0].field.push(item.field)
					if (item.field) {
						column.push({
							id: item.field,
							label: item.title
						})
					}
				})
				this.exportConfig.push({
					title: '字段',
					field: 'column',
					type: 'column',
					data: column,
					select: []
				})
				this.exportConbineColumn = this.exportSystemColumn.concat(this.exportCustomColumn)
			},
			createExportAttr() {

			},
			exportFormsChange() {

			},
			exportColumnChange(e) {
				let buff = false
				this.exportFieldType = ''
				this.exportConbineColumn.forEach((item) => {
					if (window.systemMethods.arraysAreEqual(item.field, e.checklist, false)) {
						this.exportFieldType = item.label
						buff = true
					}
				})
				if (!buff) {
					this.exportFieldType = 'customer'
				}
			},
			exportFieldTypeChange() {
				let select = []
				let obj = null
				obj = this.exportConbineColumn.find((item) => {
					return item.label == this.exportFieldType
				})
				if (obj) {
					obj.field.forEach((item) => {
						if (item) {
							select.push(item)
						}

					})
				}
				this.exportConfig[0].select = select

			},
			exportkeyword(){
				let list = this.moduleName ? this.moduleName : this.reportName
				let exportkeyword = {}
				let form = this.list.$refs[list + '_list'].getProxyInfo().form
				for (let i in form) {
					if(form[i] && !(Array.isArray(form[i]) && form[i].length==0) ){
						exportkeyword[i] = form[i]
					}
				}
				return exportkeyword
			},
			exportcurrent(obj) {
		
				let list = this.moduleName ? this.moduleName : this.reportName
				let checkData = this.list.$refs[list + '_list'].getCheckboxRecords()
				if (checkData.length == 0) {
					checkData = this.list.$refs[list + '_list'].getTableData().fullData
				}
				checkData.forEach((item) => {
					this.ids.push(item.id)
				})
				obj.ids = []
			
				this.beforeexport(obj,'current').then(()=>{
					if (this.listType == 'list') {
						obj.ids = this.ids
						this.$api[this.moduleName].export(obj).then((res) => {
							// res.data = JSON.parse(JSON.stringify(checkData))
							this.afterexport(res)
							this.exportData(res)
							this.list.loading = false
						}, () => {
							this.list.loading = false
						})

					} else {
						this.$api.report.reportexport(this.reportName, obj).then((res) => {
							res.data = JSON.parse(JSON.stringify(checkData))
							this.afterexport(res)
							this.exportData(res)
							this.list.loading = false
						}, () => {
							this.list.loading = false
						})
					}					
				})
			},
			exportTotal(obj) {
				this.beforeexport(obj,'total').then(()=>{
					this.list.loading = true
					if (this.listType == 'list') {
						this.$api[this.moduleName].export(obj).then((res) => {
							this.afterexport(res)
							this.exportData(res)
							this.list.loading = false
						}, () => {
							this.list.loading = false
						})
					} else {
						this.$api.report.reportexport(this.reportName, obj).then((res) => {
							this.afterexport(res)
							this.exportData(res)
							this.list.loading = false
						}, () => {
							this.list.loading = false
						})
					}					
				})

			},
			exportMethod() {
				this.exportNoticeShow = true
			},
			exportApi() {
				let param = {}
				if (this.exportType == 'current') {
					param.code = 'exportcurrent'
				} else {
					param.code = 'exportall'
				}
				this.list.toolbarButtonClickEvent(param, false).then(() => {
					this.ids = []
					let obj = {
						ids: this.ids,
						type: this.exportType,
						exportkeyword:this.exportkeyword()
					}
					obj = {
						...obj,
						...this.exportParam
					}
					if (obj.type == 'current') {
						this.exportcurrent(obj)
						return
					} else {
						this.ids = []
					}
					this.exportTotal(obj)
				}, () => {
					this.list.loading = false
				})
			},
			exportData(e) {
				e.data.forEach((item) => {
					for (let i in item) {
						if(i=='flowstatus'){
							if(item[i]==0){
								item[i] = '未结束'
							}
							if(item[i]==1){
								item[i] = '已结束'
							}
							if(item[i]==2){
								item[i] = '非流程'
							}
							if(item[i]==-1){
								item[i] = '保存待发'
							}	
						}
						if(i=='auditorstaffid'){
							if(item[i]){
								item[i] = '已审核'
							}else{
								item[i] = '未审核'
							}

						}
						let column = e.columns.find((col) => {
							return col.field == i
						})
						//console.log(column)
						if (column && column['formatter']) {
							item[i] = window.systemMethods.formatter(item, column)
						}
					}
				})
				let columns = []
				e.columns.forEach((item) => {
					columns.push({
						field: item.field,
						title: item.title,
						visible: item.visible,
						cellType: 'string'
					})
				})
				let gridOptions = {}
				gridOptions.columns = columns
				this.gridOptions = gridOptions
				console.log(e)
				this.$refs[this.tableRef].loadData().then(() => {
					this.$refs[this.tableRef].exportData({
						filename: e.filename?e.filename:this.windowName,
						type: 'xlsx',
						data: e.data,
					})
				})
			}
		},
		components: {

		}
	}
</script>